var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { mq, styled } from "../utils";
import Text from "./Text";
import Partners, { PartnersProps } from "./Partners";
var StyledPartners = styled(Partners)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  justify-content: space-around;\n\n  a {\n    img {\n      width: auto;\n      height: 20px;\n      margin: 0;\n    }\n  }\n\n  a:nth-of-type(1n + 5) {\n    ", "\n  }\n"], ["\n  justify-content: space-around;\n\n  a {\n    img {\n      width: auto;\n      height: 20px;\n      margin: 0;\n    }\n  }\n\n  a:nth-of-type(1n + 5) {\n    ",
    "\n  }\n"])), mq({
    display: ['none', 'block'],
}));
var MediaPartners = function (_a) {
    var title = _a.title, props = __rest(_a, ["title"]);
    return (React.createElement(React.Fragment, null,
        title && React.createElement(Text, { textAlign: "center" }, title),
        React.createElement(StyledPartners, __assign({}, props))));
};
export default MediaPartners;
var templateObject_1;
//# sourceMappingURL=MediaPartners.js.map